const _dropShadowBackgroundColor = 'rgba(0, 0, 0, 0.16)';

export { _dropShadowBackgroundColor };
